var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar',[_c('div',{attrs:{"id":"nav-bar"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" |\n  "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" |\n  "),_c('router-link',{attrs:{"to":"/blog"}},[_vm._v("Blog")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }